import { Injectable } from '@angular/core';
import { ApiRoutes } from './apiroutes';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendListModel } from '../models/common/list.model';
import { MnrDocumentTypes, MnrUserDepotMapping } from '../models/mnr-user-depot-mapping';
import { MultipleMnrUserDepotMapping } from '../models/multiple-mnr-user-depot-mapping';
import { MNR, MnrDashboard } from '../models/mnr-dashboard';
import { ComponentCodeMaster } from '../models/component-code-master';
import { MnrContainerDetails } from '../models/mnr-container-details';
import { DamageCodeMaster } from '../models/damage-code-master';
import { DamageReasonMaster } from '../models/damage-reason-master';
import { LocationCodeMaster } from '../models/location-code-master';
import { MnrDashboardDetails } from '../models/mnr-dashboard-details';
import { MnrStatusMaster } from '../models/mnr-status-master';
import { RepairCodeMaster } from '../models/repair-code-master';
import { RepairEstimate } from '../models/repair-estimate';
import { RepairEstimateLineItem } from '../models/repair-estimate-line-item';
import { RepairRejectionReason } from '../models/repair-rejection-reason';
import { MnrDetailsPsAvail } from '../models/mnr-details-ps-avail';
import { RepairedStatusChange } from '../models/repaired-status-change';
import { LocationModel } from '../models/container_master_model/location';
import { RepairEstimateReject } from '../models/repair-estimate-reject';
import { RepairStatusChange } from '../models/repair-status-change';
import { BookingDetails } from '../models/booking-details';
import { Mnrcontainerlogs } from '../models/mnrcontainerlogs';

@Injectable({
  providedIn: 'root'
})
export class MnrUserDepotmappingService {
  base_url = ApiRoutes.MNR;
  base_url1 = ApiRoutes.DepotMaster;
  base_url2 = ApiRoutes.LeadRequest
  doc_url = ApiRoutes.DocumentType;
  mnr_history: string;
  mnr_status_history: string;
  mnr_status: string
  estimateId: string;
  selectedEstCharge;
  possiblestatus: string;
  previousRoute: string;
  repairestimate: string;
  rejectPossibleStatus: string;

  searchTerm = '';

  constructor(private http: HttpClient) { }

  getMNRUserMapping(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<MnrUserDepotMapping>> {
    let url = `${this.base_url}mnr_user_depot_mapping/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<BackendListModel<MnrUserDepotMapping>>(String(urlObj));
  }
  getMNRUserMappingbyID(UDepotId: string) {
    let url = `${this.base_url}mnr_user_depot_mapping/${UDepotId}/`;
    return this.http.get<MnrUserDepotMapping>(url);
  }
  updateMNRuserMapping(data: MnrUserDepotMapping) {
    let url = `${this.base_url}mnr_user_depot_mapping/${data.id}/`;
    return this.http.put(url, data);
  }

  postMNRuserMapping(data: MnrUserDepotMapping) {
    let url = `${this.base_url}mnr_user_depot_mapping/`;
    return this.http.post(url, data);
  }
  // getDepotList(): Observable<BackendListModel<LocationModel>> {
  //   let url = `${this.base_url1}location_short/`;
  //   return this.http.get<BackendListModel<LocationModel>>(url);
  // }
  getDepotList(page_size = 300, page = 1): Observable<BackendListModel<LocationModel>> {
    let url = `${this.base_url1}location_short/?location_type_name=depot`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    return this.http.get<BackendListModel<LocationModel>>(String(urlObj));
  }

  getMNRUDashboard(page_size = 10, page = 1, search = '', order = '') {
    let url = `${this.base_url}mnr_dashboard_new/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    if (search) {
      urlObj.searchParams.append('search', String(search));
    }
    urlObj.searchParams.append('o', String(order));
    return this.http.get<MNR>(String(urlObj));
  }
  getDashboard(id, page_size = 10, page = 1, search = '', order = '') {
    let url = `${this.base_url}mnr_dashboard_new/?depot_id=${id}`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<MNR>(String(urlObj));
  }
  // get component code master
  getComponentCodeMaster() {
    let url = `${this.base_url}component_code_master/`;
    return this.http.get<ComponentCodeMaster>(url);
  }

  // get MNR container Details
  getMnrContainerDetails() {
    let url = `${this.base_url}mnr_container_details/`;
    return this.http.get<MnrContainerDetails>(url);
  }
  //post Damaged Container Pictures
  postdamagedContainer(data: MnrContainerDetails): Observable<any> {
    let url = `${this.base_url}mnr_container_details/`;
    return this.http.post(url, data);
  }

  // get Damaged Code Master
  getDamageCodeMaster() {
    let url = `${this.base_url}damage_code_master/`;
    return this.http.get<DamageCodeMaster>(url);
  }

  // get Damaged Nature Master
  getDamageNatureMaster() {
    let url = `${this.base_url}damage_nature_master/`;
    return this.http.get<DamageCodeMaster>(url);
  }

  // get Damaged Reason Master
  getDamageReasonMaster() {
    let url = `${this.base_url}damage_reason_master/`;
    return this.http.get<DamageReasonMaster>(url);
  }
  // get Location Code Master
  getLocationCodeMaster() {
    let url = `${this.base_url}location_code_master/`;
    return this.http.get<LocationCodeMaster>(url);
  }

  // get Dashboard Details
  // getMnrDashboardDetails(page_size = 10, page = 1, search = '', order = '') {
  //   let url = `${this.base_url}mnr_dashboard_details/`;
  //   let urlObj = new URL(url);
  //   urlObj.searchParams.append('page_size', String(page_size));
  //   urlObj.searchParams.append('page', String(page));
  //   urlObj.searchParams.append('search', String(search));
  //   urlObj.searchParams.append('ordering', String(order));
  //   return this.http.get<MnrDashboardDetails>(String(urlObj));
  // }
  // get Dashboard Details with ID's
  getMnrDashboardDetailsbyDepotIdStatusId(StatusType, depotId, page_size = 10, page = 1, search = '', order = '') {
    let url = `${this.base_url}mnr_dashboard_details/${StatusType}/${depotId}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<MnrDashboardDetails>(String(urlObj));
  }

  // get MNR status Master
  getMnrStatusMaster() {
    let url = `${this.base_url}mnr_status_master/`;
    return this.http.get<MnrStatusMaster>(url);
  }
  // get Repair Code Master
  getRepairCodeMaster() {
    let url = `${this.base_url}repair_code_master/`;
    return this.http.get<RepairCodeMaster>(url);
  }
  // get RepairEstimate
  getRepairEstimate() {
    let url = `${this.base_url}repair_estimate/`;
    return this.http.get<RepairEstimate>(url);
  }
  getRepairEstimatebyID(id) {
    let url = `${this.base_url}repair_estimate/${id}/`;
    return this.http.get<RepairEstimate>(url);
  }
  postRepairEstimate(data: RepairEstimate) {
    let url = `${this.base_url}repair_estimate/`;
    return this.http.post(url, data);
  }
  updateRepairEstimate(data: RepairEstimate) {
    let url = `${this.base_url}repair_estimate/${data.id}/`;
    return this.http.put(url, data);
  }
  rejectRepairEstimate(data: RepairEstimateReject) {
    let url = `${this.base_url}repair_estimate_reject/${data.id}/`;
    return this.http.put(url, data);
  }

  // get RepairEstimateLineItem
  getRepairEstimateLineItem(rowId, page_size = 10, page = 1, search = '', order = '') {
    let url = `${this.base_url}repair_estimate_line_item/?repair_estimate_id=${rowId}`;
    // repair_estimate_line_item
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<RepairEstimateLineItem>(String(urlObj));
    // return this.http.get<RepairEstimateLineItem>(url);

  }
  // repair_estimate_line_item
  postRepairEstimateLineItem(data: RepairEstimateLineItem) {
    let url = `${this.base_url}repair_estimate_line_item/`;
    return this.http.post<RepairEstimateLineItem>(url, data);
  }
  putRepairEstimateLineItem(data: RepairEstimateLineItem) {
    let url = `${this.base_url}repair_estimate_line_item/${data.id}/`;
    return this.http.put<RepairEstimateLineItem>(url, data);
  }

  // get Repair Rejection Reason
  getrepair_rejection_reason(): Observable<BackendListModel<RepairRejectionReason>> {
    let url = `${this.base_url}repair_rejection_reason/`;
    return this.http.get<BackendListModel<RepairRejectionReason>>(url);
  }

  getMNRUDashboardAvailability(page_size = 10, page = 1, search = '', order = '') {
    let url = `${this.base_url}mnr_dashboard_details_ps_avail/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));
    return this.http.get<MnrDetailsPsAvail>(String(urlObj));
  }
  //MNR Possible Status
  mnrPossibleStatusbyStatusId(status) {
    let url = `${this.base_url}mnr_possible_status/${status}/`;
    return this.http.get<MnrUserDepotMapping>(url);
  }
  //post Multiple repair estimateLineItem

  postMultipleRepairEstimateLineItem(data, repEstID) {
    let url = `${this.base_url}repair_estimate_line_item_multi/${repEstID}/`;
    return this.http.post<RepairEstimateLineItem>(url, data);
  }
  deleteMultipleRepairEstimateLineItem(repEstID) {
    let url = `${this.base_url}repair_estimate_line_item/${repEstID.id}/`;
    return this.http.delete<RepairEstimateLineItem>(url);
  }
  postRepairedDocs(data: RepairedStatusChange, id) {
    let url = `${this.base_url}repair_estimate_repaired/${id}/`;
    return this.http.put(url, data);
  }
  approveEstimate(lineItems, repEstID, recoveryCost, recoveryAmt) {
    let url = `${this.base_url}repair_estimate_approve/${repEstID}/`;
    return this.http.post<RepairEstimateLineItem>(url, { id: repEstID, line_items: lineItems, cost_recovery: recoveryCost, recovered_amount: recoveryAmt });
  }

  downloadZipPictures(id) {
    let url = `${this.base_url}container_images_zip/${id}/`;
    return this.http.get<any>(url);
  }

  sendForApproval(id) {
    let url = `${this.base_url}repair_estimate/${id}/send_mail/`;
    return this.http.put(url, {}, { observe: 'response' });
  }
  repairStatusChnage(estId, statusId) {
    let url = `${this.base_url}repair_estimate_status_change/${estId}/`;
    return this.http.put(url, {
      id: estId,
      status: statusId
    }, { observe: 'response' });
    // return this.http.get<RepairStatusChange>(url);
  }
  mnr_container_detailsbyHistoryid(historyid) {
    let url = `${this.base_url}mnr_container_details/${historyid}/`;
    return this.http.get<MnrUserDepotMapping>(url);
  }

  getDocumentTypeList(page: string) {
    let url = `${this.doc_url}?group=` + (page == 're' ? 'mnr_document' : 'mnr_repaired_docs');
    return this.http.get<MnrDocumentTypes>(url);
  }
  getBookingDetails(contid) {
    let url = `${this.base_url2}request_details/latest_quote_for_container/${contid}/`;
    return this.http.get<BookingDetails>(url);
  }
  getMNRContainerLogs(contid) {
    let url = `${this.base_url}mnr_status_history_container_logs/${contid}/`;
    return this.http.get<Mnrcontainerlogs>(url);
  }

  getDepotThread(id: string): Observable<BackendListModel<LocationModel>> {
    let url = `${this.base_url1}location_short/${id}`;
    let urlObj = new URL(url);
    return this.http.get<BackendListModel<LocationModel>>(String(urlObj));
  }
}
